import { colors } from '@single-platform/components/dist/design/designVariables';
import styled from 'styled-components';

export const EncouragementBannerContainer = styled.div`
  display: flex;
  padding: 16px 24px 16px 16px;
  border: 1px solid ${colors.base.primary.shades[5]};
  background-color: ${colors.toast['info'].background};
  border-radius: 8px;
  margin-bottom: 1.5rem;
`;

export const EncouragementBannerEmoji = styled.div`
  flex: 0.5;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 14px;
`;

export const EncouragementBannerText = styled.div`
  flex: 5;
  color: ${colors.base.primary.shades[20]};
`;

export const EncouragementBannerPrimaryText = styled.div`
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 24px;
`;

export const EncouragementBannerSecondaryText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.14px;
`;
